module.exports = __webpack_public_path__ + "media/images/forgot-logo-c3e555e410989876329cd66216d1b825.png";